import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["pane", "body", "showButton", "closeButton"];

  togglePane() {
    if (!this.bodyTarget.querySelector("form")) {
      const url = this.element.dataset.filterPaneUrlValue;
      fetch(url)
        .then(response => response.text())
        .then(html => {
          this.bodyTarget.innerHTML = html;
          $('.select2').select2();

          // Initialize the date range pickers inside the newly added HTML
          if (window.initDateRangePickers) {
            window.initDateRangePickers(this.bodyTarget);
          }
        })
        .catch(error => console.error("Error loading filters:", error));
    }
    this.paneTarget.classList.remove("d-none");
    this.paneTarget.classList.add("show");
    this.showButtonTarget.classList.add("filter-btn-hidden");
  }

  closePane() {
    this.paneTarget.classList.remove("show");
    setTimeout(() => {
      this.paneTarget.classList.add("d-none");
      this.showButtonTarget.classList.remove("filter-btn-hidden");
    }, 300);
  }
}
